import { useBandsById } from "@/lib/api";
import { Typography } from "@mui/material";
import LinkStyled from "./LinkStyled";

export default function MusicExploreCardBands({ bands, count }) {
  const { bands: loadedBands } = useBandsById(bands?.slice(0, count));

  return (
    <>
      <Typography variant="body1" className="bands">
        Mit{" "}
        {loadedBands?.map((band) => {
          return (
            <>
              <LinkStyled
                href={`/musik/${band.slug}`}
                label={band.name}
                variant="black"
              />{" "}
            </>
          );
        })}
        und vielen weiteren
      </Typography>
    </>
  );
}
